// extracted by mini-css-extract-plugin
export default {"App":"mainPage_App__Xvwoh","infoBlock":"mainPage_infoBlock__UAv5n","infoBlockDark":"mainPage_infoBlockDark__L6mlk","infoBlockAfter":"mainPage_infoBlockAfter__f-jhh"};